import React from 'react';

import useAuth from 'hooks/useAuth';

import Login from 'pages/Login/Login';

type Props = { children: JSX.Element };

const RequireAuth = ({ children }: Props) => {
	const auth = useAuth();

	if (!auth.isAuth) {
		return <Login />;
	}

	return children;
};

export default RequireAuth;
